import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39b7ec4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-[508px] mt-[12px] w-full",
  "data-testid": 'build-cache-clusters-table'
}
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col justify-center items-center h-full gap-[32px] border-System/app_border border"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex flex-col items-center gap-[12px]" }
const _hoisted_5 = { class: "text-Text/text_high font-gordita-medium text-[20px]" }
const _hoisted_6 = { class: "text-Text/text_medium" }
const _hoisted_7 = { class: "flex justify-center items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-plus" }, null, -1))
const _hoisted_9 = { "data-testid": "management-build-cache-cluster--floating-delete-row" }
const _hoisted_10 = { class: "edit-input truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center" }
const _hoisted_11 = { class: "truncate w-full text-[12px] font-gordita-regular leading-[16px] flex items-center" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediTable, IncrediButton } from 'incredi-ui';
import { computed, ref, watch } from 'vue';
import { Agent_SortOrder } from '@/graphql/codegen/generated/graphql';
import FloatingDeleteCell from '@/views/settings/components/tableCells/floatingDeleteCell.vue';
import DeleteInfoCell from '@/views/agents/components/manage-dialog/deleteInfoCell.vue';
import InputField from '@/views/agents/components/manage-dialog/inputField.vue';
import { useBuildCacheClusters } from '@/views/agents/components/buildcache-clusters/buildCacheClusters.helpers';
import EmptySearchPlaceholder from '@/components/common/empty-table-placeholder.vue';
import NO_CLUSTERS_IMG from '@/assets/images/build-cache-clusters/no_cluster.svg';
import { useI18n } from 'vue-i18n';
import { useNotify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';


export default /*#__PURE__*/_defineComponent({
  __name: 'buildCacheClustersTable',
  props: {
    isClosed: { type: Boolean },
    clusters: null
  },
  emits: ["updateTableSort", "keep-show-error"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updateTableSort', value: { name: string; descending: boolean }): void;
  (e: 'keep-show-error', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isClosed: boolean;
  clusters: any[];
}

const { toastMessage } = useNotify();
const { t } = useI18n();
const { searchInputVal, addNewClusterRow, clearNewClusterRow, isClusterNameExists, noClusters, editCluster, addNewCluster, deleteCluster } = useBuildCacheClusters();
const rowHeight = 48;
const columns = [
  { minWidth: 296, name: 'Name', sortable: true, defaultSortOrder: Agent_SortOrder.Ascending },
  { minWidth: 296, name: 'Nodes', sortable: true, defaultSortOrder: Agent_SortOrder.Descending },
];

const sort = ref({
  name: 'Name',
  descending: false,
});

const errorInputIndex = ref(-1);
const errorMessage = ref('');
const showDeleteData = ref(false);
const deleteButtonPressed = ref(false);
const hoveredRow = ref<number | undefined>(undefined);
const activeRowIndex = ref<number | undefined>(undefined); // For lock delete data
const itemRefs = ref([] as any);
const hoveredRowIndex = computed(() => {
  if (activeRowIndex.value !== undefined) {
    return activeRowIndex.value;
  }
  return hoveredRow.value;
});
const handleHoverRow = (index: number | undefined) => {
  hoveredRow.value = index;
};


watch(
  () => props.clusters,
  (newVal, oldVal) => {
    if (newVal.length > oldVal.length) {
      errorInputIndex.value = -1;
    }
  },
);

const handleSortChange = (tableState: any) => {
  sort.value = {
    name: tableState?.sort?.name || 'Name',
    descending: tableState?.sort?.descending || false,
  };
  emit('updateTableSort', sort.value);
};
const notifyIfClosed = async (msg: string, type: string) => {
  if (!props.isClosed) {
    // Clusters are being saved very fast, so it's being saved before popup is closed.
    // added small delay to show toast message after popup is closed.
    await new Promise(resolve => {
      setTimeout(resolve, 50);
    });
  }
  if (props.isClosed) {
    toastMessage(msg, type);
  }
};
const handleAddCluster = async (name: string) => {
  try {
    await addNewCluster(name);
    await notifyIfClosed('New Cluster added', CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  } catch (error) {
    toastMessage('Operation Failed, please try again', CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  }
};

const handleEditCluster = async (id: number, name: string) => {
  try {
    await editCluster(id, name);
    await notifyIfClosed('Changes saved', CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
  } catch (error) {
    toastMessage('Operation Failed, please try again', CONST_NOTIFY.MESSAGE_TYPE.ERROR);
  }
};
const resetTableValues = (index?: number) => {
  if (index !== undefined) {
    itemRefs.value?.[index].reset();
  }
  deleteButtonPressed.value = false;
  activeRowIndex.value = undefined;
  showDeleteData.value = false;
};
const setItemRef = (el: any, index: number) => {
  if (el) {
    itemRefs.value[index] = el;
  }
};

const handleDeleteRow = (index: number) => {
  if (errorInputIndex.value !== -1 && errorInputIndex.value !== index) {
    itemRefs.value[errorInputIndex.value].reset();
    errorInputIndex.value = -1;
  }
  errorInputIndex.value = -1;
  deleteButtonPressed.value = true;
  if (props.clusters[index].nodes?.length) {
    showDeleteData.value = true;
    activeRowIndex.value = index;
  } else if (props.clusters[index].id) {
    deleteCluster(props.clusters[index].id);
    deleteButtonPressed.value = false;
  } else {
    clearNewClusterRow();
    deleteButtonPressed.value = false;
  }
};

const handleUpdate = (val: string, index: number) => {
  if (!deleteButtonPressed.value) {
    errorInputIndex.value = -1;
    if (isClusterNameExists(val) || val.includes(':')) {
      errorInputIndex.value = index;
      errorMessage.value = isClusterNameExists(val) ? t('agentsTable.actionsMenu.buildCacheClusters.alreadyExistsErrorMessage') : t('agentsTable.actionsMenu.buildCacheClusters.invalidInputMessage');
      emit('keep-show-error', true);
    } else if (props.clusters[index].name === '') {
      handleAddCluster(val);
      clearNewClusterRow();
    } else {
      handleEditCluster(props.clusters[index].id, val);
      clearNewClusterRow();
    }
  } else {
    itemRefs.value?.[index].reset();
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(noClusters) && !__props.clusters?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("img", { src: _unref(NO_CLUSTERS_IMG) }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('agentsTable.actionsMenu.buildCacheClusters.noClusters')), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('agentsTable.actionsMenu.buildCacheClusters.noClustersTableTitle')), 1)
              ]),
              _createVNode(_unref(IncrediButton), {
                design: "primary-green",
                size: "small",
                rounded: true,
                class: "text-[13px] text-center font-gordita-medium",
                onClick: _unref(addNewClusterRow)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('agentsTable.actionsMenu.buildCacheClusters.noClustersTableButton')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : (_openBlock(), _createBlock(_unref(IncrediTable), {
              key: __props.clusters?.length,
              "model-value": {
          sort: sort.value,
        },
              "sort-name": sort.value.name,
              "sort-descending": sort.value.descending,
              "row-height": rowHeight,
              columns: columns as any,
              items: __props.clusters as any,
              "header-tooltip": true,
              resizable: false,
              class: _normalizeClass(["incredi-table shadow-none flex-grow w-full h-full", { 'pointer-events-none': activeRowIndex.value !== undefined || showDeleteData.value }]),
              "hovered-row-prop": _unref(hoveredRowIndex) || -1,
              "expand-row-info": { expandRowIndex: errorInputIndex.value, height: 72 },
              onHoveredRow: handleHoverRow,
              "onUpdate:modelValue": handleSortChange
            }, {
              "floating-row": _withCtx(({ index }: { index: number }) => [
                _createElementVNode("div", _hoisted_9, [
                  (index === _unref(hoveredRowIndex) && !showDeleteData.value)
                    ? (_openBlock(), _createBlock(FloatingDeleteCell, {
                        key: 0,
                        onMousedown: ($event: any) => (handleDeleteRow(index))
                      }, null, 8, ["onMousedown"]))
                    : _createCommentVNode("", true)
                ]),
                (index === activeRowIndex.value && showDeleteData.value)
                  ? (_openBlock(), _createBlock(DeleteInfoCell, {
                      key: 0,
                      message: "All Build Cache endpoints in this cluster will switch to standalone endpoints",
                      onClickOutside: resetTableValues,
                      onDeleteRow: 
              () => {
                resetTableValues();
                _unref(deleteCluster)(__props.clusters[index].id);
              }
            ,
                      onCancelDelete: ($event: any) => (resetTableValues(index))
                    }, null, 8, ["onDeleteRow", "onCancelDelete"]))
                  : _createCommentVNode("", true)
              ]),
              "content-Name": _withCtx(({ index }: { index: number }) => [
                _createElementVNode("div", {
                  "data-testid": "management-build-cache-cluster--name-cell",
                  class: _normalizeClass(["incredi-table-row !px-0 py-[6px]", { 'pointer-events-auto': activeRowIndex.value === index }])
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(InputField, {
                      ref: el => setItemRef(el, index),
                      "is-active": index === activeRowIndex.value,
                      "data-testid": "management-build-cache-cluster--name-input-field",
                      class: "build-cache-cluster-name-input",
                      "input-text": __props.clusters[index].name,
                      "min-input-length": 1,
                      ghost: index !== hoveredRow.value,
                      error: errorInputIndex.value === index,
                      "is-hovered": index === hoveredRow.value,
                      "is-valid": true,
                      "error-message": errorMessage.value,
                      onFocusWithin: 
                  () => {
                    if (errorInputIndex.value !== -1 && errorInputIndex.value !== index) {
                      itemRefs.value[errorInputIndex.value].reset();
                      errorInputIndex.value = -1;
                      _unref(clearNewClusterRow)();
                    }
                    activeRowIndex.value = index;
                  }
                ,
                      onBlurWithin: _cache[0] || (_cache[0] = 
                  () => {
                    if (!deleteButtonPressed.value) {
                      activeRowIndex.value = undefined;
                    }
                  }
                ),
                      "onClear:input": _cache[1] || (_cache[1] = 
                  () => {
                    errorInputIndex.value = -1;
                    _unref(clearNewClusterRow)();
                  }
                ),
                      "onUpdate:input": (val) => handleUpdate(val, index)
                    }, null, 8, ["is-active", "input-text", "ghost", "error", "is-hovered", "error-message", "onFocusWithin", "onUpdate:input"])
                  ])
                ], 2)
              ]),
              "content-Nodes": _withCtx(({ index }: { index: number }) => [
                _createElementVNode("div", {
                  "data-testid": "management-build-cache-cluster--assigned-agent-row",
                  class: _normalizeClass(["incredi-table-row", { 'h-fit': errorInputIndex.value, 'pointer-events-auto': activeRowIndex.value === index }])
                }, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(__props.clusters[index].nodes?.length || 0), 1)
                ], 2)
              ]),
              "no-data": _withCtx(() => [
                _createVNode(EmptySearchPlaceholder, {
                  "data-testid": 'build-cache-cluster-empty-search-placeholder',
                  "has-filters-applied": "",
                  "search-items-name": "Clear Filters",
                  "disabled-default-message-prefix": "",
                  class: "w-full h-full",
                  onClearFilters: _cache[2] || (_cache[2] = () => (searchInputVal.value = ''))
                })
              ]),
              _: 1
            }, 8, ["model-value", "sort-name", "sort-descending", "columns", "items", "hovered-row-prop", "class", "expand-row-info"]))
      ])
    ]),
    _: 1
  }))
}
}

})